<template>
  <label
    ref="root"
    :class="{
      'slo-input': true,
      [`size-${size}`]: size,
      [`variant-${variant}`]: variant,
      [`type-${type}`]: true,
      checked: checked,
      indeterminate: indeterminate,
      disabled: disabled || fieldState.disabled,
      'focus-within': fieldState.focusWithin
    }"
    v-stack-x:2xs
  >
    <slot name="start" />
    <textarea
      v-bind="$attrs"
      :value="value"
      :disabled="disabled || fieldState.disabled"
      @input.stop="handleInput"
    />
    <slot name="end" />
  </label>
</template>

<script>
export default {
  name: 'SloTextarea',
  inheritAttrs: false,
  inject: {
    fieldState: {name: 'fieldState', default: {}}
  },
  props: {
    size: {type: String},
    disabled: {type: Boolean, default: false},
    variant: {type: String},
    type: {type: String, default: 'text'},
    value: {type: [String, Number, Boolean], default: null},
    checked: {type: [Boolean], default: false},
    indeterminate: {type: [Boolean], default: false}
  },
  methods: {
    handleInput(event) {
      const type = this.type;
      if (type === 'checkbox' || type === 'radio') {
        this.$emit('input', event.target.checked);
      } else {
        this.$emit('input', event.target.value);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../scss/system';

.slo-input {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  min-height: 48px;
  background: $color-white;
  border: 1px solid $color-gray-400;
  border-radius: 4px;
  overflow: hidden;

  &.variant-inset {
    background: $color-gray-200;
    border-color: transparent;
    border-radius: 4px;

    textarea {
      background: inherit;
      border-radius: 4px;
    }
  }

  > .slo-icon:first-child {
    margin-left: 1em;
    margin-right: -8px;
  }

  > .slo-icon:last-child {
    margin-right: 1em;
    margin-left: -8px;
  }

  textarea {
    flex: 1;
    width: 100%;
    border: none;
    border-radius: 4px;
    box-shadow: none;
    margin: 0;
    padding: 12px 16px;
    height: unset;

    @include text('base');
    color: $color-gray-900;

    &::placeholder {
      color: $color-gray-700;
    }
  }

  &:focus-within {
    border-color: $color-blue-400 !important;
    outline: 1px solid transparent !important;
    box-shadow: 0 0 0 1px $color-blue-400 !important;
  }
}

.slo-input.focus-within {
  border-color: $color-blue-400 !important;
  outline: 1px solid transparent !important;
  box-shadow: 0 0 0 1px $color-blue-400 !important;
}
</style>
